import { render } from "./Change.vue?vue&type=template&id=05d9962c&scoped=true"
import script from "./Change.vue?vue&type=script&lang=js"
export * from "./Change.vue?vue&type=script&lang=js"

import "./Change.vue?vue&type=style&index=0&id=05d9962c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05d9962c"]])

export default __exports__